module.exports = function getResource(label) {
    const resources = {
        ccReward: 'Récompense Carte de crédit',
        firstPurchase: 'Premier achat',
        remove: 'Supprimer',
        apply: 'Appliquer',
        applied: 'Appliqué',
        exp: 'Exp.'
    };

    return resources[label];
};
